import { fileCdnUrl } from "./fileCdn";
export const PHONE_REGION_URL =
  fileCdnUrl("/template/mp_region.json");

const FALLBACK_PHONE_REGION = [
  { code: "+86", countryName: "中国大陆", countryNameEn: "China" },
  { code: "+852", countryName: "中国香港", countryNameEn: "Hong Kong" },
  { code: "+65", countryName: "新加坡", countryNameEn: "Singapore" },
  { code: "+44", countryName: "英国", countryNameEn: "United Kingdom" },
  { code: "+1", countryName: "美国", countryNameEn: "America" },
  { code: "+33", countryName: "法国", countryNameEn: "France" },
  { code: "+49", countryName: "德国", countryNameEn: "Germany" },
  { code: "+39", countryName: "意大利", countryNameEn: "Italy" },
  { code: "+352", countryName: "卢森堡", countryNameEn: "Luxembourg" },
  { code: "+31", countryName: "荷兰", countryNameEn: "Holland" },
  { code: "+45", countryName: "丹麦", countryNameEn: "Denmark" },
  { code: "+34", countryName: "西班牙", countryNameEn: "Spain" },
  { code: "+351", countryName: "葡萄牙", countryNameEn: "Portugal" },
  { code: "+358", countryName: "芬兰", countryNameEn: "Finland" },
  { code: "+46", countryName: "瑞典", countryNameEn: "Sweden" },
  { code: "+81", countryName: "日本", countryNameEn: "Japan" },
  { code: "+82", countryName: "韩国", countryNameEn: "Korea" },
  { code: "+91", countryName: "印度", countryNameEn: "India" },
  { code: "+48", countryName: "波兰", countryNameEn: "Poland" },
  { code: "+420", countryName: "捷克", countryNameEn: "Czechia" },
  { code: "+90", countryName: "土耳其", countryNameEn: "Turkiye" },
  { code: "+971", countryName: "阿联酋", countryNameEn: "United Arab Emirates" },
  { code: "+996", countryName: "吉尔吉斯斯坦", countryNameEn: "Kyrgyzstan" },
  { code: "+977", countryName: "尼泊尔", countryNameEn: "Nepal" },
  { code: "+66", countryName: "泰国", countryNameEn: "Thailand" }
];

let cachedPhoneRegion = null;
let pendingRequest = null;

function normalizePhoneRegionList(payload) {
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
}

/** 从 CDN 拉取手机区号列表，失败时回退本地默认数据 */
export function fetchPhoneRegion() {
  if (cachedPhoneRegion) {
    return Promise.resolve(cachedPhoneRegion);
  }
  if (pendingRequest) {
    return pendingRequest;
  }

  pendingRequest = fetch(PHONE_REGION_URL)
    .then(res => {
      if (!res.ok) {
        throw new Error(`fetch phone region failed: ${res.status}`);
      }
      return res.json();
    })
    .then(json => {
      const list = normalizePhoneRegionList(json);
      if (!list.length) {
        throw new Error("phone region list is empty");
      }
      cachedPhoneRegion = list;
      return list;
    })
    .catch(() => {
      cachedPhoneRegion = FALLBACK_PHONE_REGION;
      return FALLBACK_PHONE_REGION;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
}

/** @deprecated 请使用 fetchPhoneRegion，保留兼容旧引用 */
export const phoneRegion = FALLBACK_PHONE_REGION;
